import React from "react";

const OnboardPersonal = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_34960)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_34960)"
      />
      <g filter="url(#filter0_d_1050_34960)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M46.0998 53.4508L43.9998 55.5508L41.8998 53.4508H36.6446C36.089 53.4508 35.5562 53.2301 35.1633 52.8372C34.7705 52.4444 34.5498 51.9116 34.5498 51.356V36.6455C34.5498 35.4884 35.4875 34.5508 36.6446 34.5508H51.3551C52.5122 34.5508 53.4498 35.4884 53.4498 36.6455V51.356C53.4498 51.9116 53.2291 52.4444 52.8363 52.8372C52.4434 53.2301 51.9106 53.4508 51.3551 53.4508H46.0998ZM38.0747 50.3008H50.1392C49.4626 49.3279 48.5605 48.5332 47.51 47.9846C46.4596 47.4361 45.292 47.15 44.1069 47.1508C42.9219 47.15 41.7542 47.4361 40.7038 47.9846C39.6533 48.5332 38.7512 49.3279 38.0747 50.3008ZM43.9998 45.0508C44.4824 45.0508 44.9603 44.9557 45.4062 44.771C45.852 44.5864 46.2572 44.3157 46.5984 43.9744C46.9397 43.6331 47.2104 43.228 47.3951 42.7821C47.5797 42.3363 47.6748 41.8584 47.6748 41.3758C47.6748 40.8932 47.5797 40.4153 47.3951 39.9694C47.2104 39.5235 46.9397 39.1184 46.5984 38.7772C46.2572 38.4359 45.852 38.1652 45.4062 37.9805C44.9603 37.7958 44.4824 37.7008 43.9998 37.7008C43.0251 37.7008 42.0904 38.088 41.4012 38.7772C40.712 39.4664 40.3248 40.4011 40.3248 41.3758C40.3248 42.3505 40.712 43.2852 41.4012 43.9744C42.0904 44.6636 43.0251 45.0508 43.9998 45.0508Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_34960"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_34960"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_34960"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_34960"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_34960"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OnboardPersonal;
